import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface RealmMigrationListKeyFilter extends RequiredQueryKeyFilter {
  realmId?: string;
  teamId?: string;
  limit?: number;
  /**
   * The tenant the request authenticates as, not a filter the endpoint applies. It belongs
   * in the key because the same URL returns different rows per tenant.
   */
  tenant?: string;
}

interface RealmMigrationDetailKeyFilter extends RequiredQueryKeyFilter {
  migrationLogId: number;
  tenant?: string;
}

export const realmMigrationQueryKeys = createDefaultQueryKeysGenerator<
  RealmMigrationListKeyFilter,
  RealmMigrationDetailKeyFilter
>({
  keyDataType: 'realmMigration',
});
